import React from 'react'
import Footer from "../Components/Footer"
import Kayrakkum from '../assets/kayrakkum.jpg'
import Kayrakkumer from '../assets/kayrakkumer.jpg'
import Kids from '../assets/kids.jpg'
import Meetings from '../assets/meetings.jpg'
import Parents from '../assets/parents.jpg'
import Poselok from '../assets/poselok.jpg'
import School1 from '../assets/school1.jpg'
import School8 from '../assets/school8.jpg'
import School9 from '../assets/school9.jpg'
import We from '../assets/we.jpg'
import Remember from '../assets/remember.jpg'
import Geology from '../assets/geology.jpg'

function Gallery() {
    return (
        <div>
            <div className='max-w-[1240px] mx-auto py-3 px-[5px]]'>
                <h1 className='font-semibold md:text-3xl sm:text-2xl text-xl py-2 text-center'>Фотогалерея</h1>

                <div className='flex justify-center flex-wrap mx-auto gap-3'>

                    {/* Узнай себя старт */}

                    <div>                        
                        <a className='relative group block' href="/remember">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Узнай себя</h3>
                            <img src={Remember} />
                        </a>

                    </div>

                    {/* Узнай себя конец */}

                    {/* Школа 8 старт */}
                    <div>                        
                        <a className='relative group block' href="/school8">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Школа №8</h3>
                            <img src={School8} />
                        </a>
                    </div>

                    {/* Школа 8 конец */}

                    {/* Мы старт */}
                    <div>                        
                        <a className='relative group block' href="/we">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Мы</h3>
                            <img src={We} />
                        </a>
                    </div>

                    {/* Мы конец */}


                    {/* Школа 1 старт */}
                    <div>                        
                        <a className='relative group block' href="/school1">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Школа №1</h3>
                            <img src={School1} />
                        </a>
                    </div>

                    {/* Школа 1 конец */}


                    {/* Поселок старт */}
                    <div>                        
                        <a className='relative group block' href="/poselok">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Поселок</h3>
                            <img src={Poselok} />
                        </a>
                    </div>

                    {/* Поселок конец */}

                    {/* Родители старт */}
                    <div>                        
                        <a className='relative group block' href="/parents">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Наши родители</h3>
                            <img src={Parents} />
                        </a>
                    </div>

                    {/* Родители конец */}


                    {/* Встречи старт */}
                    <div>                        
                        <a className='relative group block' href="/meetings">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Наши встречи</h3>
                            <img src={Meetings} />
                        </a>
                    </div>

                    {/* Встречи конец */}


                    {/* Дети старт */}
                    <div>                        
                        <a className='relative group block' href="/kids">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Наши дети</h3>
                            <img src={Kids} />
                        </a>
                    </div>

                    {/* Дети конец */}


                    {/* Геология старт */}
                    <div>                        
                        <a className='relative group block' href="/geology">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Геология</h3>
                            <img src={Geology} />
                        </a>
                    </div>

                    {/* Геология конец */}


                    {/* Кайраккум старт */}
                    <div>                        
                        <a className='relative group block' href="/kayrakkum">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Кайраккум</h3>
                            <img src={Kayrakkum} />
                        </a>
                    </div>

                    {/* Кайраккум конец */}


                    {/* Кайраккумцы старт */}
                    <div>                    
                        <a className='relative group block' href="/kayrakkumer">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Кайраккумцы</h3>
                            <img src={Kayrakkumer} />
                        </a>
                    </div>

                    {/* Кайраккумцы конец */}


                    {/* Школа 9 старт */}
                    <div>                    
                        <a className='relative group block' href="/school9">
                            <h3 className='font-semibold text-2xl text-center py-2 absolute w-full h-full text-white flex items-center justify-center bg-black/[.6] group-hover:bg-transparent group-hover:text-transparent duration-500'>Школа №9</h3>
                            <img src={School9} />
                        </a>
                    </div>

                    {/* Школа 9 конец */}



                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Gallery